<!-- Header -->
@if (slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async; as label) {
  <medsurf-slide-edit-header
    [icon]="FlatModels.AnnotationEntityModels.ShapeIcon[annotation.shape]"
    [label]="label"
  [type]="'enum.annotation.' + annotation.shape"></medsurf-slide-edit-header>
}

<!-- Content -->
<div #edit_overlay_template_scroll_panel
  class="flex flex-1 overflow-auto justify-content-center">
  @if (annotation) {
    @switch (annotation.shape) {
      <!-- Free -->
      @case (FlatModels.AnnotationEntityModels.Shape.enum.free) {
        <medsurf-slide-edit-free-form-free
        class="flex flex-1"></medsurf-slide-edit-free-form-free>
      }
      <!-- Interactive Area -->
      @case (FlatModels.AnnotationEntityModels.Shape.enum.interactiveArea) {
        <medsurf-slide-edit-free-form-interactive-area
        class="flex flex-1"></medsurf-slide-edit-free-form-interactive-area>
      }
      <!-- Line -->
      @case (FlatModels.AnnotationEntityModels.Shape.enum.line) {
        <medsurf-slide-edit-free-form-line
        class="flex flex-1"></medsurf-slide-edit-free-form-line>
      }
      <!-- Shape -->
      @default {
        <medsurf-slide-edit-free-form-shape
        class="flex flex-1"></medsurf-slide-edit-free-form-shape>
      }
    }
  }
</div>
